import React from 'react';
import PropTypes from 'prop-types';
import {
  OrderDetailsPage,
  TitleRow,
  Title,
  TitleImage,
  OrderTable,
  TableTr,
  TableTBody,
  TableTd,
} from './OrderDetails.styles';

export const CustomSellerOrderDetails = ({ selectedOrder: { email, applicationPlatform } }) => {
  return (
    <OrderDetailsPage className="order-details-page">
      <TitleRow className="row title-row">
        <div className="col-xs-12">
          <Title className="title">Order Summary</Title>
          <span>
            <TitleImage className="svg title-image" alt="" src="/images/green-clipboard.svg" />
          </span>
        </div>
      </TitleRow>

      <hr />
      <OrderTable className="order-table">
        <TableTBody>
          <TableTr>
            <TableTd>Email</TableTd>
            <TableTd>{email}</TableTd>
          </TableTr>
          <TableTr>
            <TableTd>Application Platform</TableTd>
            <TableTd>{applicationPlatform}</TableTd>
          </TableTr>
        </TableTBody>
      </OrderTable>
    </OrderDetailsPage>
  );
};

CustomSellerOrderDetails.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      value: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    })
  ),
};

export default CustomSellerOrderDetails;
